import { isEmptyObject } from "../../../utils/tests";
import { LiveScoreQuery, LiveScoreSubscription } from "../types";

export const isValidLiveScoreQuery = (obj: LiveScoreQuery): boolean =>
  Boolean(obj?.data?.getLiveScore && !isEmptyObject(obj.data.getLiveScore));

export const isValidLiveScoreSubscription = (
  obj: LiveScoreSubscription
): boolean =>
  Boolean( obj?.data?.onUpdateLiveScoreById && !isEmptyObject(obj.data.onUpdateLiveScoreById) );
